import { PredefinedAppointmentDay } from "@/Appointments/Models/Scheduling/PredefinedAppointmentDay";
import { CalendarSlotV2, WorkDayV2 } from "@/Appointments/Models/Scheduling/WorkDayV2";
import { CliniciansHelper } from "@/Common/Helpers/CliniciansHelper";
import { Guid } from "@/Common/Models/Guid";
import { Person } from "@/Common/Models/Person/Person";
import { SchedulerDisplayMode } from "@/Common/Models/UI/Enums";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IPatientAppointmentModel } from "@/Patient/Models/UI/Appointment/IPatientAppointmentModel";
import { PatientStore } from "@/Patient/Stores/PatientStore";
import { AppointmentManagement } from "./AppointmentManagement";
import { AppointmentScheduler } from "./AppointmentScheduler";
import { PredefinedAppointmentSave } from "./PredefinedAppointmentSave";
import { ServiceFinder } from "./ServiceFinder";

interface IAppointment {
    Model: IPatientAppointmentModel;
    patientId: Guid;
    shouldIgnorePublicationRules: boolean;
}

class Appointment extends React.Component<IAppointment, any> {
    public render(): JSX.Element {
        const workDaysV2 = this.props.Model.get("TimeSlot").map((p: PredefinedAppointmentDay) => {
            var workDay = new WorkDayV2();
            workDay.date = p.ControlDate;

            workDay.calendarSlots = [];
            p.BlueRectanlge.forEach(n => workDay.calendarSlots.push(CalendarSlotV2.fromPredefinedAppointmentGroup(n)));

            workDay.calendarSlots = workDay.calendarSlots.sortByProperty(slot => slot.fromRaw);

            return workDay;
        }).toList();

        const schedMode = this.props.Model.get("IsSchedulerInStackMode") ? SchedulerDisplayMode.Stacked : SchedulerDisplayMode.Classic;

        const IsSearchCriteriaEditPopupOpen = this.props.Model.get("ShowCriteriaSelectionWindow");

        return (
            <div
                className="appointment-container scrollable"
                onClick={() => {
                    if (IsSearchCriteriaEditPopupOpen == true) {
                        LocalEvent.Dispatch(LocalPatientOperations.Appointment.OnOkClick);
                    }
                }}
            >
                <div className="">
                    {this.renderLeftSide()}
                </div>
                {this.props.Model.get("ShowManagement") && (
                    <div className="" style={{ marginTop: "30px" }}>
                        <AppointmentScheduler
                            month={0}
                            workDaysV2={workDaysV2}
                            displayMode={schedMode}
                            Model={this.props.Model}
                            shouldIgnorePublicationRules={this.props.shouldIgnorePublicationRules}
                        />
                    </div>
                )}
            </div>
        );
    }

    public async componentDidMount(): Promise<void> {
        $(window).trigger("resize");

        const defaultClinician = await this.GetDefaultClinician(this.props.patientId, patientStore);

        sessionStore.dispatch(LocalPatientOperations.Appointment.onAppointmentMount, { defaultClinicianValue: defaultClinician }, 300);
    }

    public componentDidUpdate(): void {
        const selectedClinician = this.props.Model.get("CliniciansFiltered")?.find(c => c.Checked);
        const defaultClinicianElement = document.getElementById(selectedClinician?.ContactFacetId);
        if (defaultClinicianElement != undefined)
            defaultClinicianElement.scrollIntoView({ block: "nearest" });
    }

    private async GetDefaultClinician(patientId: Guid, store: PatientStore): Promise<Person> {
        const patient = store.getPersonModel(patientId);
        if (!patient) return undefined;
        const patientClinicians = await CliniciansHelper.getStarredAndRamqRegisteredClinicians(patient);
        return patientClinicians;
    }

    private renderLeftSide(): JSX.Element {
        var jsx = null;
        if (this.props.Model.get("ShowManagement") === true) {
            jsx = this.renderAppointmentManagement();
        }
        if (this.props.Model.get("ShowCriteriaSelectionWindow") === true) {
            jsx = this.renderServiceFinder();
        }
        if (this.props.Model.get("ShowSavePredefinedAppointment") === true) {
            jsx = this.renderSavePredefinedAppointment();
        }
        return jsx;
    }

    private renderAppointmentManagement(): JSX.Element {
        return <AppointmentManagement Model={this.props.Model} />;
    }

    private renderServiceFinder(): JSX.Element {
        return <ServiceFinder Model={this.props.Model} />;
    }

    private renderSavePredefinedAppointment(): JSX.Element {
        return <PredefinedAppointmentSave patientContactId={this.props.patientId} model={this.props.Model.get("PredefinedAppointmentSaveState")} customDuration={this.props.Model.get("CustomDuration")} />;
    }
}

export { Appointment };
